import { gql } from "@apollo/client";

import { organizationsFragment, rolesFragment, userProfileFragment } from "../fragments";

export const getUserInfo = gql`
    ${organizationsFragment}
    ${rolesFragment}
    ${userProfileFragment}

    query getUserInfo {
        getMyLensesOrganizations {
            ...Organizations
        }
        getMyLensesRoles {
            ...MyLensesRoles
        }
        getUserProfile {
            ...UserProfile
        }
    }
`;
